import React from 'react';
import SuceesfulIcon from '../../assets/successful.png';
import dash from '../../assets/dash.png';
import copyicon from '../../assets/copyicon.png';
import {Link} from 'react-router-dom'
import toast from 'react-hot-toast'

export default function Successful({value, amount}){

 function copied(){
    toast.success("copied");
     navigator.clipboard.writeText(value)
 }

 console.log(value)

    return(
        <div className='AlertBackground'>
            <center>
                <img src={SuceesfulIcon} alt="successful image"/>
                <div className='successfultitle'>
                Payment Sucessful
                </div>
                <img src={dash} alt="dash icons" className="dash"/>
                <table style={{width:"100%"}}>
                    <tr>
                        <td className='successfulDetailTitle'>
                        Amount Paid:
                        </td>
                        <td style={{marginLeft:5, float:"right"}} className='successfulDetailTitle'>
                        ₦{Math.round(amount)}
                        </td>
                   </tr>   
                    <tr className='successfulspacing2' >
                    <td >
                            TrackingId:
                        </td>
                        <td style={{display:"flex", alignItems:"center", float:"right", height:60}}>
                        <div>{value}</div><img src={copyicon} style={{marginLeft:5}} alt="copyicon" onClick={() => {copied()}} className="copyicon"/>
                        </td>
                    </tr>
                </table>
                <div className="Link" style={{marginTop:20}}>
                <Link to="/">
                    Go back Home
                </Link>
                </div>
            </center>
        </div>
    )
}